export default __webpack_public_path__ + "static/media/comment.2c032b9a.png";